module.exports = __webpack_public_path__ + "img/topicEnvironment.48a84a5b.svg";